__turbopack_context__.v({
  "actions": "projects-section-module-scss-module__SUVPiG__actions",
  "btn": "projects-section-module-scss-module__SUVPiG__btn",
  "btnIcon": "projects-section-module-scss-module__SUVPiG__btnIcon",
  "card": "projects-section-module-scss-module__SUVPiG__card",
  "cardDesc": "projects-section-module-scss-module__SUVPiG__cardDesc",
  "cardGlow": "projects-section-module-scss-module__SUVPiG__cardGlow",
  "cardHover": "projects-section-module-scss-module__SUVPiG__cardHover",
  "cardTitle": "projects-section-module-scss-module__SUVPiG__cardTitle",
  "cardWrap": "projects-section-module-scss-module__SUVPiG__cardWrap",
  "container": "projects-section-module-scss-module__SUVPiG__container",
  "grid": "projects-section-module-scss-module__SUVPiG__grid",
  "number": "projects-section-module-scss-module__SUVPiG__number",
  "section": "projects-section-module-scss-module__SUVPiG__section",
  "subtitle": "projects-section-module-scss-module__SUVPiG__subtitle",
  "techList": "projects-section-module-scss-module__SUVPiG__techList",
  "techTag": "projects-section-module-scss-module__SUVPiG__techTag",
  "title": "projects-section-module-scss-module__SUVPiG__title",
  "titleBlock": "projects-section-module-scss-module__SUVPiG__titleBlock",
  "titleLine": "projects-section-module-scss-module__SUVPiG__titleLine",
});
